import { lazy } from "react"

const ContributionVisualizationPage$$__react__lazy__component = lazy(() => 
    import("./ContributionVisualizationPage__original__module.mjs")
        .then(module => module.get_$$ContributionVisualizationPage$$ContributionVisualizationPage$$react__component$$b0k1ymcpaa4e())
        .then(component => ({ default: component }))
)

export const get_$$ContributionVisualizationPage$$ContributionVisualizationPage$$react__component$$b0k1ymcpaa4e = () => ContributionVisualizationPage$$__react__lazy__component